import $ from "jquery";

$(function () {
    $(".facility-link").on("click", function (this: HTMLElement) {
        // Get the data-facility attribute value
        const facilityUrl = $(this).data("facility") as string | null;

        // Check if the data-facility attribute exists and is not empty
        if (facilityUrl) {
            // Redirect to the URL contained in the data-facility attribute
            window.location.href = facilityUrl;
        }
    });
});
